<template>
     <v-container fluid>
     <v-row class="mx-0">
        <v-col md="8" lg="6">
          <v-card outlined>
            <v-card-title class="text-h6 font-weight-regular">
              User Profile
              <v-spacer/>
              <v-btn 
                text 
                class="mx-2" 
                fab 
                dark 
                color="primary"
                @click="openEditUserProfileDialog"
              >
                <v-icon dark>mdi-pencil</v-icon>
              </v-btn>
                <v-dialog 
                    v-model="editUserProfileDialog" 
                    max-width="500"
                    persistent
                    eager
                >
                    <v-tabs-items class="transparent" v-model="tab" align-center justify-center>
                        <v-tab-item>
                            <v-card :loading="loading">
                                <v-card-title class="justify-space-between">
                                    Edit User Profile
                                    <v-btn fab text small @click="editUserProfileDialog = false"><v-icon class="text-right text--secondary">close</v-icon></v-btn>
                                </v-card-title>
                                <v-card-text class="py-0">
                                    <v-alert
                                        dense
                                        text
                                        prominent
                                        color="primary"
                                        v-if="editUserProfileServerError!=''"
                                    >
                                        <v-row align="center">
                                            <v-col class="grow">{{editUserProfileServerError}}</v-col>
                                        </v-row>
                                    </v-alert>
                                    <v-form ref="editUserProfileForm">
                                        <v-container>
                                            <v-row>
                                                <v-col class="pt-0">
                                                <v-text-field validate-on-blur :readonly="loading" :rules="nameRules" label="First Name" required outlined dense v-model="firstName"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="pt-0">
                                                <v-text-field validate-on-blur :readonly="loading" :rules="nameRules" label="Last Name" required outlined dense v-model="lastName"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="pt-0">
                                                <v-text-field :readonly="loading" validate-on-blur :rules="emailRules" label="Email" required outlined dense v-model="email"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="pt-0">
                                                <v-btn
                                                    large 
                                                    elevation="0"
                                                    color="primary"
                                                    block
                                                    @click="updateUserProfile()"
                                                >
                                                    Save
                                                </v-btn>
                                                </v-col>
                                            </v-row>
                                            <!-- <v-row>
                                                <v-col class="pt-0">
                                                <v-btn
                                                    large
                                                    text
                                                    elevation="0"
                                                    color="primary"
                                                    block
                                                    @click="editUserProfileDialog = false"
                                                >
                                                    Cancel
                                                </v-btn>
                                                </v-col>
                                            </v-row> -->
                                        </v-container>
                                    </v-form>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item eager>
                            <v-card :loading="loading">
                                <v-card-title>
                                    Please Confirm
                                </v-card-title>
                                <v-card-subtitle>
                                    Please confirm this change by providing your password.
                                </v-card-subtitle>
                                <v-card-text>
                                    <v-alert
                                        dense
                                        text
                                        prominent
                                        color="primary"
                                        v-if="confirmChangesPasswordServerError!=''"
                                    >
                                        <v-row align="center">
                                            <v-col class="grow">{{confirmChangesPasswordServerError}}</v-col>
                                        </v-row>
                                    </v-alert>
                                    <v-form ref="confirmChangesForm">
                                         <v-text-field
                                            dense
                                            label="Password"
                                            prepend-inner-icon="mdi-lock"
                                            outlined
                                            v-model="confirmChangesPassword"
                                            :append-icon="confirmChangesShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="confirmChangesShowPassword ? 'text' : 'password'"
                                            @click:append="confirmChangesShowPassword = !confirmChangesShowPassword"
                                            :rules="passwordRules"
                                            required
                                        ></v-text-field>
                                    </v-form>
                                    <v-btn
                                        class="mt-2 text-body-1" 
                                        large 
                                        elevation="0"
                                        color="primary"
                                        block
                                        @click="handleConfirmChanges"
                                    >
                                        Confirm
                                    </v-btn>
                                    <v-btn
                                    class="mt-2 text-body-1" 
                                    large
                                    text
                                    elevation="0"
                                    color="primary"
                                    block
                                    @click="editUserProfileDialog = false"
                                >
                                    Cancel Changes
                                </v-btn>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </v-dialog>






























            </v-card-title>
            <v-card-text>
              <v-row class="mx-1 my-2">
                <span class="text--secondary font-weight-light">First Name</span>
                <v-spacer/>
                <span class="text--primary">{{userProfile.firstName}}</span>
              </v-row>
              <v-divider/>
              <v-row class="mx-1 my-2">
                <span class="text--secondary font-weight-light">Last Name</span>
                <v-spacer/>
                <span class="text--primary">{{userProfile.lastName}}</span>
              </v-row>
               <v-divider/>
              <v-row class="mx-1 my-2">
                <span class="text--secondary font-weight-light">Email Name</span>
                <v-spacer/>
                <span class="text--primary">{{userProfile.email}}</span>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
     </v-row>
     <v-row class="mx-0">
        <v-col md="8" lg="6">
          <v-card outlined>
            <v-card-title class="text-h6 font-weight-regular">
              Security
              <v-spacer/>
              <v-btn 
                text 
                class="mx-2" 
                fab 
                dark 
                color="primary"
                @click="openChangePasswordDialog"
              >
                <v-icon dark>mdi-pencil</v-icon>
              </v-btn>









                 <v-dialog 
                    v-model="changePasswordDialog" 
                    max-width="500"
                    persistent
                    eager
                >
                    <v-card :loading="loading">
                        <v-card-title class="justify-space-between">
                            Change Password
                            <v-btn fab text small @click="changePasswordDialog = false"><v-icon class="text-right text--secondary">close</v-icon></v-btn>
                        </v-card-title>
                        <v-card-text class="py-0">
                             <v-alert
                                dense
                                text
                                prominent
                                color="primary"
                                v-if="changePasswordServerError!=''"
                            >
                            <v-row align="center">
                                <v-col class="grow">{{changePasswordServerError}}</v-col>
                            </v-row>
                            </v-alert>
                            <v-form ref="changePasswordForm">
                            <v-container>
                                <v-row>
                                    <v-col class="pt-0">
                                        <v-text-field
                                            id="oldPassword"
                                            label="Current Password"
                                            name="oldPassword"
                                            outlined
                                            v-model="oldPassword"
                                            dense
                                            :append-icon="show0 ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="show0 ? 'text' : 'password'"
                                            :readonly="loading"
                                            hint="At least 8 characters"
                                            counter
                                            validate-on-blur
                                            @click:append="show0 = !show0"
                                            :rules="passwordRules"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pt-0">
                                        <v-text-field
                                            id="newPassword"
                                            label="New Password"
                                            name="newPassword"
                                            outlined
                                            v-model="newPassword"
                                            dense
                                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="show1 ? 'text' : 'password'"
                                            :readonly="loading"
                                            hint="At least 8 characters"
                                            counter
                                            validate-on-blur
                                            @click:append="show1 = !show1"
                                            :rules="passwordRules"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pt-0">
                                        <v-text-field
                                            id="confirmPassword"
                                            label="Confirm Password"
                                            name="confirmPassword"
                                            outlined
                                            v-model="confirmPassword"
                                            dense
                                            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="show2 ? 'text' : 'password'"
                                            :readonly="loading"
                                            counter
                                            @click:append="show2 = !show2"
                                            :rules="[() => newPassword == confirmPassword || 'The passwords don\'t match', v => !!v || 'Please retype your password']"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pt-0">
                                    <v-btn
                                        large 
                                        elevation="0"
                                        color="primary"
                                        block
                                        @click="changePassword()"
                                    >
                                        Save
                                    </v-btn>
                                    </v-col>
                                </v-row>
                                <!-- <v-row>
                                    <v-col class="pt-0">
                                    <v-btn
                                        large
                                        text
                                        elevation="0"
                                        color="primary"
                                        block
                                        @click="changePasswordDialog = false"
                                    >
                                        Cancel
                                    </v-btn>
                                    </v-col>
                                </v-row> -->
                            </v-container>
                        </v-form>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-card-title>
            <v-card-text>
              <v-row class="mx-1 my-2">
                <span class="text--secondary font-weight-light">Password</span>
                <v-spacer/>
                <span class="text--primary">********</span>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
    </v-row>
        <v-snackbar
            v-model="snackbar"
            left
            multi-line
            :timeout="snackbarTimeout"
        >
            {{ snackbarText }}

            <template v-slot:action="{ attrs }">
            <v-btn
                color="primary"
                text
                v-bind="attrs"
                @click="snackbar = false"
                top
            >
                Close
            </v-btn>
            </template>
        </v-snackbar>
     </v-container>
</template>
<script>
import { signInWithEmailAndPassword, updatePassword } from 'firebase/auth';
import {getAuth} from "@/shared/firebase_utils";
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'AccountSettings',
    data() {
        return {
            tab: 0,
            editUserProfileDialog: false,
            changePasswordDialog: false,
            firstName: '',
            lastName: '',
            email: '',
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            changePasswordServerError: '',
            show0: false,
            show1: false,
            show2: false,
            passwordRules: [
                v => !!v || 'Please enter your password',
                v => v.length >= 8 || 'The password must be at least 8 characters long',
            ],
            emailRules: [
                v => !!v || 'Please enter your email',
                v => /.+@.+\..+/.test(v) || 'Invalid email',
            ],
            nameRules: [
                v => !!v || 'This field is required',
            ],
            snackbar: false,
            snackbarText: '',
            snackbarTimeout: 6000,
            loading: false,
            confirmChangesPassword: '',
            confirmChangesShowPassword: false,
            confirmChangesPasswordServerError: '',
            editUserProfileServerError: '',
        };
    },
    computed: mapGetters(['userProfile']),
    methods: {
        ...mapActions(['updateUserProfileDetails']),
        openEditUserProfileDialog() {
            // alert('Edit User Profile');
            this.$refs.editUserProfileForm.resetValidation();
            this.$refs.confirmChangesForm.resetValidation();
            this.tab = 0;
            this.editUserProfileDialog = true;
            this.firstName = this.userProfile.firstName;
            this.lastName = this.userProfile.lastName;
            this.email = this.userProfile.email;
            this.confirmChangesPassword = '';
            this.loading = false;
            this.confirmChangesPasswordServerError = '';
            this.editUserProfileServerError = '';
        },
        openChangePasswordDialog() {
            // alert('Change Password');
            this.$refs.changePasswordForm.resetValidation() ;
            this.oldPassword = '';
            this.newPassword = '';
            this.confirmPassword = '';
            this.changePasswordServerError = '';
            this.changePasswordDialog = true;
        },
        async updateUserProfile() {
            if(this.loading)
                return;
            if(this.$refs.editUserProfileForm.validate()) {
                this.tab = 1;
                this.confirmChangesPassword = '';
                this.editUserProfileServerError = ''
            }
        },
        async handleConfirmChanges() {
            const auth = getAuth();
            if(this.loading)
                return;
            if(this.$refs.confirmChangesForm.validate()) {
                this.loading = true;
                
                signInWithEmailAndPassword(auth, this.userProfile.email, this.confirmChangesPassword)
                .then(async (userCredential) => {
                    //User Authenticated successfully
                    if(this.userProfile.email != this.email) {
                        await userCredential.user.updateEmail(this.email).then(async () => {
                            // Update successful.
                            console.log('Email associated to the acccount has been updated successfully');
                            await this.updateUserProfileDetails({ 
                                firstName: this.firstName, 
                                lastName: this.lastName, 
                                email: this.email,
                            });
                            this.$router.push('/');
                        }).catch((error) => {
                            // An error happened.
                            this.loading = false;
                            this.tab = 0;
                            this.editUserProfileServerError = error.message;
                            this.confirmChangesPassword = '';
                            this.$refs.confirmChangesForm.resetValidation();
                            console.log(error.message);
                        }); 
                    }
                    
                    if(this.userProfile.firstName != this.firstName || this.userProfile.lastName != this.lastName) {
                        await this.updateUserProfileDetails({ 
                            firstName: this.firstName, 
                            lastName: this.lastName, 
                            email: this.email,
                        });
                        this.loading = false;
                        this.editUserProfileDialog = false;
                        this.snackbarText = 'Saved successfully!';
                        this.snackbar = true;
                    }

                }).catch(error => {
                    if(error.code == "auth/wrong-password")
                        this.confirmChangesPasswordServerError = "Incorrect password";
                    else
                        this.confirmChangesPasswordServerError = error.message;
                    this.loading = false;
                });    
            }
        },
        changePassword() {
            if(this.loading)
                return;
            if(this.$refs.changePasswordForm.validate()) {
                const auth = getAuth();
                this.loading = true;
                this.changePasswordServerError = "";
                signInWithEmailAndPassword(auth, this.userProfile.email, this.oldPassword)
                .then((user) => {
                    updatePassword(user.user, this.newPassword).then(() => {
                        this.loading = false;
                        this.changePasswordDialog = false;
                        console.log('Password updated successfully');
                        this.snackbarText = 'Password updated successfully!';
                        this.snackbar = true;
                        //Do something

                    }).catch((error) => {
                        this.changePasswordServerError = error.message;
                        console.log(error.message);
                        this.loading = false;
                    });
                }).catch((error) => {
                    if(error.code == "auth/wrong-password")
                        this.changePasswordServerError = "Incorrect current password";
                    else
                        this.changePasswordServerError = error.message;
                    console.log(error.message);
                    this.loading = false;
                });
            }
        },
    },
}
</script>